import { ImmutableStore } from 'fluxible-immutable-utils';
import FormState from '../constants/FormState';
import Actions from '../constants/Actions';

const defaultState = {
  emailAddress: '',
  activationKey: '',
  formState: FormState.INITIAL
};

class ResetPasswordStore extends ImmutableStore {
  static storeName = 'ResetPasswordStore';

  static handlers = {
    [Actions.AUTHENTICATION__ACTIVATION_KEY_FOUND]: 'handleActivationKeyFound',
    [Actions.AUTHENTICATION__PASSWORD_RESET_STARTED]: 'passwordResetStarted',
    [Actions.AUTHENTICATION__PASSWORD_RESET_FAILED]: 'passwordResetFailed',
    [Actions.AUTHENTICATION__PASSWORD_RESET_COMPLETED]: 'passwordResetCompleted',
    [Actions.AUTHENTICATION__PASSWORD_RESET_FORM_STATE_CHANGED]: 'formStateChanged'
  };

  constructor(dispatcher) {
    super(dispatcher);
    this.setState(defaultState);
  }

  handleActivationKeyFound({ activationKey, emailAddress }) {
    this.mergeState({
      activationKey: activationKey,
      emailAddress: emailAddress
    });
  }

  getEmailAddress() {
    return this.get('emailAddress');
  }

  getFormState() {
    return this.get('formState');
  }

  getActivationKey() {
    return this.get('activationKey');
  }

  formStateChanged(formState) {
    this.mergeState({
      formState
    });
  }

  passwordResetStarted() {
    return this.mergeState({
      formState: FormState.PROCESSING
    });
  }

  passwordResetCompleted() {
    this.mergeState({
      formState: FormState.COMPLETED
    });
  }

  passwordResetFailed() {
    this.mergeState({
      formState: FormState.FAILURE
    });
  }
}

export default ResetPasswordStore;



// WEBPACK FOOTER //
// ./src/stores/ResetPasswordStore.js